export default __webpack_public_path__ + "static/media/banco-agrario.ed5792a6.svg";